export default "__VITE_ASSET__DZhhkY2S__"